import { checkRefreshToken, getTokensFromCookies } from './AuthApi';

// Формируем базовый URL динамически
const BASE_USER_URL = window?.APP_CONFIG?.API_URL;

/**
 * Универсальная функция для выполнения запросов.
 * @param {string} url - URL запроса (например, `/api/session/login`).
 * @param {object} options - Параметры запроса (метод, заголовки, тело и т.д.).
 * @returns {Promise<any>} - Результат запроса в формате JSON.
 */
export async function request(url, options = {}) {
  // Проверяем токен перед любым запросом
  await checkRefreshToken();

  const { a_token } = getTokensFromCookies();
  if (a_token) {
    options.headers = {
      ...options.headers,
      Authorization: `Bearer ${a_token}`,
    };
  }

  const response = await fetch(`${BASE_USER_URL}${url}`, options);

  if (!response.ok) {
    console.log(response)
    if (response.status === 401) {
      // глобальный logout
      window.dispatchEvent(new Event('force-logout'));
    }

    let errorResponse = {
      status: response.status,
      statusText: response.statusText,
    };

    try {
      const serverErrorData = await response.json();
      errorResponse = { ...errorResponse, ...serverErrorData };
    } catch (e) {
      const errorText = await response.text();
      errorResponse.errorText = errorText;
    }

    throw errorResponse;
  }

  return await response.json();
}

/**
 * Функция для выполнения GET-запроса с параметрами.
 * @param {string} url - URL запроса.
 * @param {object} params - Объект с параметрами.
 * @returns {Promise<any>} - Результат запроса в формате JSON.
 */
export async function getRequest(url, params = {}) {
  const query = new URLSearchParams(params).toString();
  const fullUrl = query ? `${url}?${query}` : url;
  return request(fullUrl);
}

/**
 * Универсальная функция для отправки POST, PUT, DELETE запросов.
 * @param {string} url - URL запроса.
 * @param {string} method - HTTP-метод (POST, PUT, DELETE).
 * @param {object} data - Данные, которые нужно отправить.
 * @returns {Promise<any>} - Результат запроса в формате JSON.
 */
export async function sendRequest(url, method, data = {}) {
  return request(url, {
    method,
    headers: {
      'Content-Type': `application/json`,
    },
    body: JSON.stringify(data),
  });
}

/**
 * Универсальная функция для отправки FormData (например, файлов).
 * @param {string} url - URL запроса.
 * @param {string} method - HTTP-метод (POST, PUT, DELETE).
 * @param {FormData} formData - Объект FormData с данными.
 * @returns {Promise<any>} - Результат запроса в формате JSON.
 */
export async function sendFormDataRequest(url, method, formData) {
  return request(url, {
    method,
    body: formData,
  });
}

/**
 * Функция обновления токена.
 * @param {object} data - Данные для обновления токена.
 * @returns {Promise<any>} - Обновленные данные токена.
 */
export async function refreshToken(data) {
  try {
    const response = await fetch(`${BASE_USER_URL}/session/refresh`, {
      method: `POST`,
      headers: {
        'Content-Type': `application/json`,
      },
      credentials: 'include',
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error(`Failed to refresh token`);
    }

    return await response.json();
  } catch (error) {
    console.error(`Ошибка обновления токена:`, error);
    throw error;
  }
}
